<template>
    <div id="resource">

    </div>
</template>

<script>
export default {
    name: "Resource"
}
</script>

<style lang="css" scoped>

</style>